// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ygup","col":"styles_col__TeWun"};